<template>
    <v-app>
        
        <!-- header component -->
        <header-card-public ref="refHeader" current_page="landing"></header-card-public>

        <!-- main / landing content section  -->
        <v-content :class="isMobile?'section1-mobile':'section1'">

            <!-- desktop view -->
            <v-layout v-if="!isMobile" fill-height align-center row wrap>
                <v-flex xs12>

                    <div class="section1-div">
                        
                        <!-- Main Title -->
                        <h1 class="section1-main-header text-xs-center mb-4">
                            {{ content.default.title }}
                        </h1>

                        <!-- description 1 -->
                        <div class="section1-main-sub-header text-xs-center">
                           {{ content.default.description1 }}
                        </div>

                        <!-- description 2 items -->
                        <div class="mt-4 mb-4 text-xs-center">
                            <!-- The master container restricts the width so 5 long items physically cannot fit in a single line -->
                            <div class="section1-description2">
                                
                                <!-- The v-for loops over the elements -->
                                <div 
                                    v-for="(item, index) in content.default.description2" 
                                    :key="index"
                                    class="pa-1"
                                >
                                    <v-chip 
                                        label
                                        class="sweldo-pill-chip"
                                    >
                                        <v-icon small class="mr-2 primary--text">
                                            {{ item.icon }}
                                        </v-icon>
                                        
                                        <span class="font-weight-medium grey--text text--darken-3">
                                            {{ item.description }}
                                        </span>
                                    </v-chip>
                                </div>
                            </div>
                        </div>

                        <div class="mt-10 mb-20 primary--text font-weight-bold text-xs-center">
                            {{ content.default.description4 }}
                        </div>

                        <!-- Primary CTA (Behaves as an inline block naturally) -->
                        <div class="text-xs-center">
                        
                            <v-btn large dark class="primary rounded-4 no-uppercase mr-4" @click="showBookForDemo">
                                <v-icon left>app_registration</v-icon>
                                <b>{{ content.default.button1 }}</b>
                            </v-btn>

                            <!-- Secondary CTA -->
                            <v-btn large flat class="rounded-4 no-uppercase primary--text" @click="scrollDown">
                                {{ content.default.button2 }}
                                <v-icon right small class="ml-1">arrow_downward</v-icon>
                        </v-btn>

                        </div>

                    </div>
                </v-flex>
            </v-layout>

            <!-- mobile view -->
            <v-layout v-if="isMobile" fill-height align-center row wrap>
                <v-flex xs12 sm6>
                    <div class="section1-mobile-div text-xs-center">
                        <div class="mt-10 mb-10">   

                            <!-- main title -->
                            <div class="section1-main-header" >
                                {{ content.default.title }}
                            </div>

                            <hr class="grey--text mt-10 mb-10">

                            <!-- description 1 -->
                            <div class="section1-main-sub-header">
                                {{ content.default.description1 }}
                            </div>

                            <hr class="grey--text mt-10 mb-10">
                            
                            <!-- description 2 items -->
                            <div class="mt-4 mb-4 text-xs-center">
                                <!-- The master container restricts the width so 5 long items physically cannot fit in a single line -->
                                <div class="section1-description2">
                                    
                                    <!-- The v-for loops over the elements -->
                                    <div 
                                        v-for="(item, index) in content.default.description2" 
                                        :key="index"
                                    >
                                        <v-chip 
                                            label
                                            small
                                            class="sweldo-pill-chip-mobile"
                                        >
                                            <v-icon small class="mr-2 primary--text">
                                                {{ item.icon }}
                                            </v-icon>
                                            
                                            <span class="font-weight-medium grey--text text--darken-3">
                                                {{ item.description }}
                                            </span>
                                        </v-chip>
                                    </div>
                                </div>
                            </div>
                            
                        </div>

                        <!-- <hr class="grey--text mt-10 mb-10">
                        <div class="mt-10 mb-10 primary--text font-weight-bold">
                            {{ content.default.description4 }}
                        </div> -->
                        
                        <!-- sign-up and explore features buttons -->
                        <div class="text-xs-center mt-10">
                            <v-btn large block dark @click="showBookForDemo" class="primary rounded-4 mb-10">
                                <v-icon class="mr-5">app_registration</v-icon>
                                <b>{{content.default.button1}}</b>
                            </v-btn>
                            <v-btn flat block dark @click="scrollDown" class="no-uppercase primary--text rounded-4">
                                {{content.default.button2}}<v-icon class="ml-5">arrow_downward</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
            
        </v-content>
        
        <!-- details section -->
        <v-content>
            <div v-for="(item,index) in content.details" :key="index">
                <section-content 
                    :data="item" 
                    :image_location="index%2==0?'right':'left'" 
                    :section_class="`section-${index%2==0?'right':'left'}`" 
                    :id="item.id" :section_id="item.id">
                </section-content>
            </div>
        </v-content>

        <!-- FOOTER -->
        <v-footer dark height="auto">
            <footer-card></footer-card>
        </v-footer>
        
        <!-- <cookie-alert v-if="cookieDialog" :cookieDialog.sync="cookieDialog"></cookie-alert> -->

        <v-snackbar v-model="isNoInternet" color="warning" :bottom="y === 'top'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="0" :top="y === 'top'" :vertical="mode === 'vertical'"
            >You have no internet connection.
        </v-snackbar>

        <v-btn v-show="showScrollTop" small fab dark fixed bottom right color="primary" class="mb-5 mr-5" @click="scrollToTop" title="Scroll to top">
            <v-icon>keyboard_arrow_up</v-icon>
        </v-btn>
    </v-app>
</template>
<script>

import * as easings from 'vuetify/es5/util/easing-patterns'
import '@/assets/css/public.css' 

export default {
    name: 'Portal',
    metaInfo: {
        title: 'Portal',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: '' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'section-content': () => import('@/components/SectionContent'),
        'header-card-public': () => import('@/components/HeaderPublic'),
        'footer-card': () => import('@/components/Footer'),
        // 'cookie-alert': () => import('@/components/CookieAlert'),
    },
    data () {
        return {
            loading: false,
            disabled: false,
            error: false,
            errorMessage: null,
            duration: 750,
            offset: 70,
            mode: null,
            x: null,
            y: null,
            easing: 'easeInOutCubic',
            dialogConfirmation: false,
            cookieDialog: false,
            isNoInternet: false,
            showScrollTop: false,

            //version 3 - sell the problem strategy - then summarized
            content: {
                default: {
                    title: 'The Operating System For Your Workforce',
                    description1: 'Manage your Philippine workforce through one secure cloud platform.',
                    description2: [
                        { icon: 'payments', description: "Automated Payroll"},
                        { icon: 'currency_exchange', description: "Multi-Currency"},
                        { icon: 'badge', description: "HR Suite"},
                        { icon: 'fingerprint', description: "FaceAI Attendance"},
                        { icon: 'account_balance_wallet', description: "Finance & Expenses"},
                        { icon: 'gavel', description:  "Compliance & Tax"},
                    ],
                    description4: 'Trusted by BPO and IT companies serving clients around the world.',
                    button1: 'Book A Free Demo',
                    button2: 'Explore Features',
                },
                details: [
                    {
                        id: "payroll_compliance",
                        nextId: "attendance_faceai",
                        group: "Payroll & BIR Compliance",
                        title: "Tired of the Monthly Payroll and BIR Filing Headache?",
                        description: "Payroll errors cause complaints, risks, and penalties. <b>SweldoNow</b> automates payroll, tax, annualization and reporting in one platform.",
                        details: [
                            {
                                icon: "calculate",
                                title: "Payroll in Minutes, Not Days",
                                description: "<b>SweldoNow</b> automatically computes salaries, overtime, and deductions — no more spreadsheet errors."
                            },
                            {
                                icon: "assignment_turned_in",
                                title: "Stay Compliant with Confidence",
                                description: "Generate BIR‑ready reports and tax documents instantly."
                            },
                            {
                                icon: "event_note",
                                title: "End Year-End Stress",
                                description: "Automate annualization and BIR 2316 prep to end year‑end stress."
                            }
                        ],
                        image: { fileName: "our-customers2.jpg", orientation: "landscape", elevation: 20 },
                        tags: ["Batch Payroll Processing", "Annualization", "Auto-generated BIR Reports"]
                    },
                    {
                        id: "attendance_faceai",
                        nextId: "employee_self_service",
                        group: "Attendance & FaceAI",
                        title: "Still Guessing Who Actually Reported?",
                        description: "Buddy punching and manual logs drain resources. <b>SweldoNow FaceAI</b> makes every clock‑in verifiable and payroll‑ready.",
                        details: [
                            {
                                icon: "verified_user",
                                title: "Eliminate Attendance Fraud",
                                description: "Verify identity at clock‑in to stop attendance fraud."
                            },
                            {
                                icon: "devices",
                                title: "Built for Office, Field, and Remote Teams",
                                description: "Capture attendance via mobile or tablet — no costly hardware."
                            },
                            {
                                icon: "fact_check",
                                title: "Accurate Attendance, Accurate Payroll",
                                description: "Accurate records flow straight into payroll."
                            }
                        ],
                        image: { fileName: "FaceAI4.jpg", orientation: "landscape", elevation: 20 },
                        tags: ["Face AI Attendance Tracker", "Selfie Attendance Tracker"]
                    },
                    {
                        id: "employee_self_service",
                        nextId: "finance",
                        group: "Employee Self-Service",
                        title: "Is Your HR Team Spending Too Much Time on Routine Requests?",
                        description: "Routine HR requests eat up hours. <b>SweldoNow</b> empowers employees to self‑manage while HR focuses on strategy.",
                        details: [
                            {
                                icon: "person",
                                title: "Let Employees Help Themselves",
                                description: "Give employees instant access to payslips, leave requests, and personal updates — anytime, anywhere."
                            },
                            {
                                icon: "folder_shared",
                                title: "Unlimited HR 201 Files",
                                description: "Store contracts, IDs, and employee documents securely with unlimited AWS cloud storage."
                            },
                            {
                                icon: "edit_document",
                                title: "SweldoNow eDocuments",
                                description: "Distribute policies and capture digital signatures with full audit trails — no chasing acknowledgements."
                            }
                        ],
                        image: { "fileName": "selfservice1.jpg", "orientation": "landscape", elevation: 20 },
                        tags: ["HR 201 Files", "Digital Signatures", "Approval Workflow"]
                    },
                    {
                        id: "finance",
                        nextId: "security_passwordless_login",
                        group: "Finance Requests",
                        title: "Stop Tracking Loans and Reimbursements in Spreadsheets",
                        description: "Manual tracking slows down HR and finance. <b>SweldoNow</b> centralizes requests in one transparent workflow.",
                        details: [
                            {
                                icon: "account_balance_wallet",
                                title: "Loan Payments, Cash Advances & Reimbursements",
                                description: "Employees request and track financial transactions digitally — faster, clearer, and fully auditable."
                            },
                            {
                                icon: "sync_alt",
                                title: "Integrated with Payroll",
                                description: "Approved requests automatically reflect in payroll, reducing errors and manual work."
                            }
                        ],
                        image: { fileName: "finance1.jpg", orientation: "landscape", elevation: 20 },
                        tags: ["Loan Payments", "Cash Advances", "Reimbursements"]
                    },
                    {
                        id: "security_passwordless_login",
                        nextId: "one_platform",
                        group: "Security & Passwordless Login",
                        title: "Stop Password Risks. Start Secure Access.",
                        description: "Payroll data is sensitive. <b>SweldoNow</b> secures it with passwordless authentication and enterprise‑grade protection.",
                        details: [
                            {
                                icon: "fingerprint",
                                title: "Passwordless Authentication",
                                description: "Login with passkeys, Face ID, or fingerprint — no passwords."
                            },
                            {
                                icon: "lock",
                                title: "Enterprise-Grade Data Protection",
                                description: "Multi‑layer encryption and strict access controls safeguard data."
                            },
                            {
                                icon: "admin_panel_settings",
                                title: "Control Who Sees What",
                                description: "Role‑based permissions ensure only authorized access."
                            }
                        ],
                        image: { fileName: "security4.png", orientation: "portrait", elevation: 20 },
                        tags: ["Device Login", "Biometrics Authentication"]
                    },
                    {
                        id: "one_platform",
                        nextId: "testimonials",
                        group: "Replace Multiple Systems with One Platform",
                        title: "Why Pay for Five Different Systems When One Can Do It All?",
                        description: "Stop juggling five systems. <b>SweldoNow</b> unifies payroll, HR, attendance, finance, and compliance in one secure cloud platform.",
                        details: [
                            {
                                icon: "hub",
                                title: "One Source of Truth",
                                description: "One source of truth for all workforce data."
                            },
                            {
                                icon: "savings",
                                title: "Lower Software Costs",
                                description: "Lower costs by replacing multiple tools."
                            },
                            {
                                icon: "trending_up",
                                title: "Scale as Your Company Grows",
                                description: "Scale easily from 20 to hundreds of employees."
                            }
                        ],
                        image: { fileName: "one_platform2.png", orientation: "landscape", elevation: 0 },
                        tags: []
                    },
                    {
                        id: "testimonials",
                        nextId: "why_trust_sweldonow",
                        group: "You're Not the Only One Looking for a Better Way",
                        title: "You're Not the Only One Looking for a Better Way",
                        description: "Businesses across industries trust <b>SweldoNow</b> to simplify payroll, improve attendance, and reduce admin work.",
                        details: [
                            {
                                icon: "support_agent",
                                title: "Support That Actually Cares",
                                description: "Responsive support that understands payroll challenges."
                            },
                            {
                                icon: "workspaces",
                                title: "Built for Real-World Complexity",
                                description: "Handles complex shifts, approvals, and remote teams."
                            },
                            {
                                icon: "check_circle",
                                title: "Trusted for Accuracy",
                                description: "Trusted for accuracy in payroll and compliance."
                            }
                        ],
                        image: { fileName: "why-choose-us.jpg", orientation: "landscape", elevation: 20 },
                        tags: []
                    },
                    {
                        id: "why_trust_sweldonow",
                        group: "Why Trust SweldoNow?",
                        title: "Why Trust SweldoNow?",
                        description: "Payroll is about compliance, security, and continuity. <b>SweldoNow</b> was built for Philippine businesses needing reliability.",
                        details: [
                            {
                                icon: "corporate_fare",
                                title: "Trusted by BPO & IT Companies",
                                description: "Proven reliability for complex payroll structures."
                            },
                            {
                                icon: "gavel",
                                title: "Built for Philippine Compliance",
                                description: "Automated computations and BIR‑ready reporting reduce risks."
                            },
                            {
                                icon: "cloud_done",
                                title: "Modern Cloud Platform",
                                description: "Secure cloud access from anywhere — no costly servers."
                            },
                            {
                                icon: "shield",
                                title: "Security by Design",
                                description: "Passwordless login, audit trails, and encryption by design."
                            },
                            {
                                icon: "apps",
                                title: "More Than Payroll Software",
                                description: "Combines payroll, HR, attendance, finance, and compliance in one tool."
                            },
                            {
                                icon: "rocket_launch",
                                title: "Focus on Growing Your Business",
                                description: "Spend less time on admin, more on growth."
                            }
                        ],
                        image: { fileName: "why-choose-us.png", orientation: "landscape", elevation: 0 },
                        tags: []
                    },
                ]
            },
        }
    },
    methods: {
        handleScroll() {
            this.showScrollTop = window.scrollY > 300
        },
        scrollToTop() {
            this.$vuetify.goTo(0, {
                duration: 600,
                easing: 'easeInOutCubic'
            })
        },
        showBookForDemo() {
            this.$router.push('/book-demo')
        },
        showProductDemo() {
            window.open("https://help.sweldonow.ph/demo/")
        },
        showConfirmation() {
            this.dialogConfirmation = true
        },
        scrollDown() {
            this.$vuetify.goTo(this.firstSection, this.options)
        },
        updateConnectionStatus() {
            this.isNoInternet = !navigator.onLine;
            this.isSlowInternet = navigator.connection.downlink < 1.5
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
        window.addEventListener('online', this.updateConnectionStatus)
        window.addEventListener('offline', this.updateConnectionStatus)
    },
    created() {
        this.updateConnectionStatus()
        const savedCookieDialog = localStorage.getItem('cookieDialog')
        this.cookieDialog = savedCookieDialog ? false : true
    },
    computed: {
        firstSection() {
            return `#${this.content.details[0].id}`
        },
        options () {
            return {
                duration: this.duration,
                offset: this.offset,
                easing: this.easing
            }
        },
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
        window.removeEventListener('online', this.updateConnectionStatus)
        window.removeEventListener('offline', this.updateConnectionStatus)
    }
}
</script>